// extracted by mini-css-extract-plugin
export default {"logoutcontainer":"logout_logoutcontainer__ySCln","optioncontainer":"logout_optioncontainer__yWTqe","buttonContainer":"logout_buttonContainer__KXaKK","yes":"logout_yes__4jzFc"};